export default {
  API_URL: "https://api.incentive.digitory.dev/manager",
};
